import ConnectionBanner from "@rimble/connection-banner";
import React from 'react';
export default {
  ConnectionBanner,
  React
};